import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { Redirect, Route } from 'react-router-dom';
import { loginActions } from './../store/user-login.reducer';
import ExternalLayout from './../components/external/external-layout.component';
import DashboardPageLayout from './../components/external/dashboard/dashboard-page-layout.component';
import InvalidAccess from './../components/common/login/invalid-access.component';
// --- External Requests ---
import RequestPageLayout from './../components/external/request/request-page-layout.component';
// --- External Reports ---
import ReportsPage from './../components/external/reports/report-page.component';
import OrderVolumePage from './../components/external/reports/order-volume.page';
import InventoryCircuitPage from '../components/external/inventory/Circuit/inventory-circuit.page';
import InventoryEquipment from '../components/external/inventory/equipment/inventory-equipment.page';
import InventoryASPU from '../components/external/inventory/aspu/inventory-aspu.component';
import InventoryASR from '../components/external/inventory/asr/inventory-asr.component';
import CostReportPage from './../components/external/reports/cost-report.page';
import { CostReportTable } from './../components/external/reports/cost-report/cost-report.component';
import CsatReportPage from './../components/external/reports/csat-report.page';
//New Report
import { CircuitInventory } from './../components/external/reports/custom-report/circuit-inventory';
import { Accrual } from './../components/external/reports/custom-report/accrual.component';
import { Order } from './../components/external/reports/custom-report/order.component';
import { DisputeReport } from './../components/external/reports/custom-report/dispute.component';
import { AccountReport } from './../components/external/reports/custom-report/account.component';
import { HrReport } from './../components/external/reports/custom-report/hr.component';
import { CostReport } from './../components/external/reports/custom-report/cost.component';
import { ExpectedBilling } from './../components/external/reports/custom-report/expected-billing.component';
import { CostAllocation } from './../components/external/reports/custom-report/cost-allocation.component';
import { InvoiceReport } from './../components/external/reports/custom-report/invoice-report.component';
import { SemiAnnualReport } from './../components/external/reports/custom-report/semi-annual.component';
import { InvoiceCalendarReport } from './../components/external/reports/custom-report/invoice-calendar-report.component';
import { SpendReport } from './../components/external/reports/custom-report/spend.component';
import { HighSpendReport } from './../components/external/reports/custom-report/high-spend.component';
import { UsageReport } from './../components/external/reports/custom-report/usage.component';
import { CallByType } from './../components/external/reports/custom-report/call-by-type';
import { RollingTrend } from './../components/external/reports/custom-report/rolling-trend.component';
import { TelcomVendor } from './../components/external/reports/custom-report/telcom.component';
import { MDUM } from './../components/external/reports/custom-report/mdum.component';
import { ZeroUsage } from './../components/external/reports/custom-report/zero-usage.component';
import { ExterNalInvoice } from './../components/external/reports/invoice/invoice.component'
import { InvoiceUpload } from './../components/external/reports/invoice/invoice-upload.component';
import { InvoiceChargeMapping } from './../components/external/reports/invoice/invoice-charge-mapping.component';
import { InvoiceCalendar } from './../components/external/reports/invoice/invoice-calendar.component';

import LinkedInvoiceDetails from "./../components/external/invoice/linked-invoice/linked-invoices.component";
import LinkedCircuitDetails from './../components/external/inventory/linked-circuits/circuit-details.component';

/*Release Notes*/
import ReleaseNotes  from './../components/external/release-notes/release-notes.component'

import InvoiceInvoice from '../components/external/invoice/invoice/invoice.components';

import InvoiceDispute from '../components/external/invoice/dispute/dispute.components';
import { DisputeForm } from '../components/external/invoice/dispute/dispute-form';
import DisputeFilter from '../components/external/invoice/dispute/dispute-form-filter/dispute-filter.component';
import ChargeMapping from '../components/external/invoice/invoice-upload/charge-mapping/charge-mapping';

class ExternalRoutes extends Component {

    async componentWillMount() {
        await this.props.getUserRoutes();
    }

    render() {
        const { userRoutes } = this.props;
        //const userRoutes = sessionStorage.getItem('UserExternalRoutes').split(",");
        const checkAccess = (path, permittedRoutes) => {
            let isUserAuthorised = false;

            if (Array.isArray(permittedRoutes) && permittedRoutes.length > 0) {
                isUserAuthorised = permittedRoutes.includes(path);
                return isUserAuthorised === true;
            }
            return false;
        };
        return (
            <div>
                <ExternalLayout isUserLoggedIn={true}>
                    { /*DASHBOARD*/}
                    <Route exact path="/external" render={props => <Redirect to={{ pathname: '/external/' + sessionStorage.getItem('DealName') + '/Dashboard' }} />} />
                    <Route exact path="/external/:dealName" render={props => <Redirect to={{ pathname: '/external/' + sessionStorage.getItem('DealName') + '/Dashboard' }} />} />

                    <Route path="/external/:dealName/Dashboard" render={props =>
                    ( false //checkAccess("/external/:dealName/Dashboard", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<DashboardPageLayout {...props} />)
                    )
                    } />


                    { /*REQUESTS*/}
                    <Route path="/external/:dealName/Requests" render={props =>
                    (checkAccess("/external/:dealName/Requests", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<RequestPageLayout {...props} />)
                    )
                    } />

                    { /*REPORTS*/}
                    <Route exact path="/external/:dealName/Reports" render={props =>
                    (checkAccess("/external/:dealName/Reports", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<ReportsPage {...props} />)
                    )
                    } />
                    <Route exact path="/external/:dealName/Reports/OrderReport" render={props =>
                    (checkAccess("/external/:dealName/Reports/OrderReport", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<Order {...props} />)
                    )
                    } />
                    {/* <Route exact path="/external/:dealName/Reports/InventoryReport" render={props =>
                    (checkAccess("/external/:dealName/Reports/InventoryReport", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<InventoryPage {...props} />)
                    )
                    } /> */}
                    <Route exact path="/external/:dealName/Reports/Cost" render={props =>
                    (checkAccess("/external/:dealName/Reports/Cost", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<CostReportPage {...props} />)
                    )
                    } />
                    <Route exact path="/external/:dealName/Reports/CostReport" render={props =>
                    (checkAccess("/external/:dealName/Reports/CostReport", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<CostReportTable {...props} />)
                    )
                    } />
                    <Route exact path="/external/:dealName/Reports/CsatReport" render={props =>
                    (checkAccess("/external/:dealName/Reports/CsatReport", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<CsatReportPage {...props} />)
                    )
                    } />

                    {/* New Report */}
                    <Route exact path="/external/Reports/Order" render={props =>
                    (checkAccess("/external/Reports/Order", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<Order {...props} />)
                    )
                    } />
                    <Route exact path="/external/Reports/Dispute" render={props =>
                    (checkAccess("/external/Reports/Dispute", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<DisputeReport {...props} />)
                    )
                    } />
                    <Route exact path="/external/Reports/Circuit-Inventory" render={props =>
                    (checkAccess("/external/Reports/Circuit-Inventory", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<CircuitInventory {...props} />)
                    )
                    } />
                    <Route exact path="/external/Reports/Accrual" render={props =>
                    (checkAccess("/external/Reports/Accrual", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<Accrual {...props} />)
                    )
                    } />
                    <Route exact path="/external/Reports/Account" render={props =>
                    (checkAccess("/external/Reports/Account", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<AccountReport {...props} />)
                    )
                    } />
                    <Route exact path="/external/Reports/HR" render={props =>
                    (checkAccess("/external/Reports/HR", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<HrReport {...props} />)
                    )
                    } />
                    <Route exact path="/external/Reports/Cost-Report" render={props =>
                    (checkAccess("/external/Reports/Cost-Report", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<CostReport {...props} />)
                    )
                    } />
                    <Route exact path="/external/Reports/Expected-Billing-Report" render={props =>
                    (checkAccess("/external/Reports/Expected-Billing-Report", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<ExpectedBilling {...props} />)
                    )
                    } />
                    <Route exact path="/external/Reports/Cost-Allocation-Report" render={props =>
                    (checkAccess("/external/Reports/Cost-Allocation-Report", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<CostAllocation {...props} />)
                    )
                    } />
                    <Route exact path="/external/Reports/Invoice-Report" render={props =>
                    (checkAccess("/external/Reports/Invoice-Report", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<InvoiceReport {...props} />)
                    )
                    } />
                    <Route exact path="/external/Reports/Semi-Annual-Report" render={props =>
                    (checkAccess("/external/Reports/Semi-Annual-Report", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<SemiAnnualReport {...props} />)
                    )
                    } />
                    <Route exact path="/external/Reports/Invoice-Calendar-Report" render={props =>
                    (checkAccess("/external/Reports/Invoice-Calendar-Report", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<InvoiceCalendarReport {...props} />)
                    )
                    } />
                    <Route exact path="/external/Reports/Spend-Report" render={props =>
                    (checkAccess("/external/Reports/Spend-Report", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<SpendReport {...props} />)
                    )
                    } />
                    <Route exact path="/external/Reports/High-Spender-Report" render={props =>
                    (checkAccess("/external/Reports/High-Spender-Report", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<HighSpendReport {...props} />)
                    )
                    } />
                    <Route exact path="/external/Reports/Usage-Report" render={props =>
                    (checkAccess("/external/Reports/Usage-Report", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<UsageReport {...props} />)
                    )
                    } />
                    <Route exact path="/external/Reports/Calls-By-Type" render={props =>
                    (checkAccess("/external/Reports/Calls-By-Type", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<CallByType {...props} />)
                    )
                    } />
                    <Route exact path="/external/Reports/Rolling-Trend-Report" render={props =>
                    (checkAccess("/external/Reports/Rolling-Trend-Report", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<RollingTrend {...props} />)
                    )
                    } />
                    <Route exact path="/external/Reports/Telcom-Vendor-Payment-Register" render={props =>
                    (checkAccess("/external/Reports/Telcom-Vendor-Payment-Register", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<TelcomVendor {...props} />)
                    )
                    } />
                    <Route exact path="/external/Reports/MDUM-Report" render={props =>
                    (checkAccess("/external/Reports/MDUM-Report", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<MDUM {...props} />)
                    )
                    } />
                    <Route exact path="/external/Reports/Zero-Usage-Report" render={props =>
                    (checkAccess("/external/Reports/Zero-Usage-Report", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<ZeroUsage {...props} />)
                    )
                    } />

                    <Route exact path="/external/Invoice/Invoice" component={ExterNalInvoice} />

                    {/* Inventory  */}
                    <Route exact path="/external/Inventory/Circuit" render={props =>
                    (checkAccess("/external/Inventory/Circuit", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<InventoryCircuitPage {...props} />)
                    )
                    } />
                    <Route exact path="/external/Inventory/Equipment" render={props =>
                    (checkAccess("/external/Inventory/Equipment", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<InventoryEquipment {...props} />)
                    )
                    } />
                    <Route exact path="/external/Inventory/ASPU" render={props =>
                    (checkAccess("/external/Inventory/ASPU", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<InventoryASPU {...props} />)
                    )
                    } />
                    <Route exact path="/external/Inventory/ASR" render={props =>
                    (checkAccess("/external/Inventory/ASR", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<InventoryASR {...props} />)
                    )
                    } />

                    <Route exact path="/external/inventory/linked-circuit/:linkedCircuitID" render={props =>
                    (checkAccess("/external/inventory/linked-circuit/:linkedCircuitID", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<LinkedCircuitDetails {...props} />)
                    )
                    } />

                    {/* Invoices  */}
                    <Route exact path="/external/Invoices/Invoices" render={props =>
                    (checkAccess("/external/Invoices/Invoices", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<InvoiceInvoice {...props} />)
                    )
                    } />

                    <Route exact path="/external/invoice/linked-invoice/:linkedInvoiceID" render={props =>
                    (checkAccess("/external/invoice/linked-invoice/:linkedInvoiceID", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<LinkedInvoiceDetails {...props} />)
                    )
                    } />

                    <Route exact path="/external/Invoices/Disputes" render={props =>
                    (checkAccess("/external/Invoices/Disputes", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<InvoiceDispute {...props} />)
                    )
                    } />

                    <Route exact path="/external/Invoices/InvoiceUpload" render={props =>
                    (checkAccess("/external/Invoices/InvoiceUpload", userRoutes) == false
                        ? (<Redirect to={{ pathname: '/InvalidAccess' }} component={InvalidAccess} />)
                        : (<ChargeMapping {...props} />)
                    )
                    } />

                   

                    {/* Dispute Form */}
                    <Route exact path="/external/Invoices/Disputes/New" component={DisputeFilter} />
                    <Route exact path="/external/Invoices/Disputes/DisputeDetails/:disputeID" component={DisputeFilter} />

                    <Route exact path="/external/Inventory/matched-circuit/:linkedCircuitID" component={LinkedCircuitDetails} />                                
                    {/*Release Notes*/}

                    <Route exact path="/external/:dealName/ReleaseNotes" component={ReleaseNotes} />
                </ExternalLayout>
            </div>
        );
    }

}

export default connect(
    state => {
        const { authentication } = state;
        return {
            ...authentication
        };
    },
    dispatch =>
        bindActionCreators(
            Object.assign({}, loginActions),
            dispatch
        )
)(ExternalRoutes);